"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[397],{

/***/ 63961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ executionIntervalLabel; }
/* harmony export */ });
var executionIntervalDisplay = {
  minute: ['minute', 'minutes'],
  half_hourly: ['half hour', 'half hours'],
  hourly: ['hour', 'hours'],
  daily: ['day', 'days'],
  half_daily: ['half day', 'half days'],
  weekly: ['week', 'weeks'],
  fortnightly: ['fortnight', 'fortnights'],
  monthly: ['month', 'months']
};
var executionIntervalLabel = {
  minute: 'Every minute',
  half_hourly: 'Half-hourly',
  hourly: 'Hourly',
  daily: 'Daily',
  half_daily: 'Half-daily',
  weekly: 'Weekly',
  fortnightly: 'Fortnightly',
  monthly: 'Monthly'
};
/* harmony default export */ __webpack_exports__["Z"] = (executionIntervalDisplay);

/***/ }),

/***/ 18437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ findPair; }
/* harmony export */ });
/* harmony import */ var _utils_pair__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17987);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83706);


function findPair(pairs, resultingDenom, initialDenom) {
  var initialAsQuote = (0,rambda__WEBPACK_IMPORTED_MODULE_0__/* .find */ .s)(function (pair) {
    return (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getBaseDenom */ .m)(pair).id === resultingDenom.id && (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getQuoteDenom */ .v)(pair).id === initialDenom.id;
  }, pairs);

  if (initialAsQuote) {
    return initialAsQuote;
  }

  return (0,rambda__WEBPACK_IMPORTED_MODULE_0__/* .find */ .s)(function (pair) {
    return (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getBaseDenom */ .m)(pair).id === initialDenom.id && (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getQuoteDenom */ .v)(pair).id === resultingDenom.id;
  }, pairs);
}

/***/ }),

/***/ 34886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
function formatDate(date) {
  if (!date) {
    return '-';
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

/***/ }),

/***/ 22349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getEndDateFromRemainingExecutions; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86831);

function getEndDateFromRemainingExecutions(strategy, startDate, remainingExecutions) {
  if ((0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(strategy.rawData.time_interval) === 'object') {
    var customIncrements = strategy.rawData.time_interval.custom.seconds;
    startDate.setSeconds(startDate.getSeconds() + customIncrements * remainingExecutions);
    return startDate;
  }

  switch (strategy.rawData.time_interval) {
    case 'minute':
      startDate.setMinutes(startDate.getMinutes() * remainingExecutions);
      break;

    case 'half_hourly':
      startDate.setMinutes(startDate.getMinutes() + 30 * remainingExecutions);
      break;

    case 'hourly':
      startDate.setHours(startDate.getHours() + remainingExecutions);
      break;

    case 'daily':
      startDate.setDate(startDate.getDate() + remainingExecutions);
      break;

    case 'half_daily':
      startDate.setHours(startDate.getHours() + 12 * remainingExecutions);
      break;

    case 'weekly':
      startDate.setDate(startDate.getDate() + 7 * remainingExecutions);
      break;

    case 'monthly':
      startDate.setMonth(startDate.getMonth() + remainingExecutions);
      break;

    default:
      return undefined;
  }

  return startDate;
}

/***/ }),

/***/ 6686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mc": function() { return /* binding */ getAveragePurchasePrice; },
  "rY": function() { return /* binding */ getAverageSellPrice; },
  "HF": function() { return /* binding */ getBasePrice; },
  "I9": function() { return /* binding */ getNextTargetTime; },
  "a5": function() { return /* binding */ getPriceThreshold; },
  "OJ": function() { return /* binding */ getSlippageTolerance; },
  "oY": function() { return /* binding */ getSlippageToleranceFormatted; },
  "uo": function() { return /* binding */ getStrategyBalance; },
  "AO": function() { return /* binding */ getStrategyEndDate; },
  "FN": function() { return /* binding */ getStrategyEndDateFromRemainingExecutions; },
  "H0": function() { return /* binding */ getStrategyExecutionInterval; },
  "ps": function() { return /* binding */ getStrategyExecutionIntervalData; },
  "vB": function() { return /* binding */ getStrategyInitialDenom; },
  "LR": function() { return /* binding */ getStrategyName; },
  "Cx": function() { return /* binding */ getStrategyPriceTrigger; },
  "wW": function() { return /* binding */ getStrategyRemainingExecutions; },
  "xT": function() { return /* binding */ getStrategyResultingDenom; },
  "sS": function() { return /* binding */ getStrategyStartDate; },
  "dC": function() { return /* binding */ getStrategyType; },
  "Pg": function() { return /* binding */ getSwapAmount; },
  "bX": function() { return /* binding */ getTargetPrice; },
  "ZD": function() { return /* binding */ getTotalReceived; },
  "pG": function() { return /* binding */ getTotalReceivedBeforeFees; },
  "cc": function() { return /* binding */ getTotalSwapped; },
  "sh": function() { return /* binding */ isBuyStrategy; },
  "KT": function() { return /* binding */ isStrategyActive; },
  "WD": function() { return /* binding */ isStrategyAutoStaking; },
  "iF": function() { return /* binding */ isStrategyCancelled; },
  "sf": function() { return /* binding */ isStrategyCompleted; },
  "KF": function() { return /* binding */ isStrategyOperating; },
  "Qs": function() { return /* binding */ isStrategyScheduled; }
});

// UNUSED EXPORTS: convertReceiveAmount, getStrategyInitialDenomId, getStrategyTotalFeesPaid

// EXTERNAL MODULE: ./src/models/Strategy.ts
var Strategy = __webpack_require__(22149);
// EXTERNAL MODULE: ./src/models/StrategyType.tsx
var StrategyType = __webpack_require__(94705);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
// EXTERNAL MODULE: ./src/utils/totalExecutions.tsx
var totalExecutions = __webpack_require__(66260);
// EXTERNAL MODULE: ./src/helpers/findPair.ts
var findPair = __webpack_require__(18437);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/utils/pair.ts
var utils_pair = __webpack_require__(17987);
// EXTERNAL MODULE: ./src/utils/safeInvert.tsx
var safeInvert = __webpack_require__(90019);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/helpers/executionIntervalDisplay.tsx
var executionIntervalDisplay = __webpack_require__(63961);
// EXTERNAL MODULE: ./src/helpers/format/formatDate.tsx
var formatDate = __webpack_require__(34886);
// EXTERNAL MODULE: ./src/helpers/getEndDateFromRemainingExecutions.tsx
var getEndDateFromRemainingExecutions = __webpack_require__(22349);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/helpers/getLastExecutionDateFromStrategyEvents.tsx

function getLastExecutionDateFromStrategyEvents(events) {
  var lastExecutionEvent = (0,lodash.findLast)(events, function (event) {
    var data = event.data;

    if ('dca_vault_execution_triggered' in data) {
      return data.dca_vault_execution_triggered;
    }

    return false;
  }); // vault has no executions yet

  if (!lastExecutionEvent) {
    return undefined;
  }

  return new Date(Number(lastExecutionEvent.timestamp) / 1000000);
}
;// CONCATENATED MODULE: ./src/helpers/isAutoStaking.ts
function isAutoStaking(destinations) {
  return destinations.length > 0 && destinations[0].address.startsWith('kujiravaloper');
}
// EXTERNAL MODULE: ./src/helpers/strategy/isWeightedScale/index.ts
var isWeightedScale = __webpack_require__(19766);
// EXTERNAL MODULE: ./src/helpers/strategy/isDcaPlus/index.ts
var strategy_isDcaPlus = __webpack_require__(67207);
;// CONCATENATED MODULE: ./src/helpers/strategy/index.ts

















function isStrategyOperating(strategy) {
  return strategy.status === Strategy/* StrategyStatus.ACTIVE */.L.ACTIVE || strategy.status === Strategy/* StrategyStatus.SCHEDULED */.L.SCHEDULED;
}
function isStrategyActive(strategy) {
  return strategy.status === Strategy/* StrategyStatus.ACTIVE */.L.ACTIVE;
}
function isStrategyScheduled(strategy) {
  return strategy.status === Strategy/* StrategyStatus.SCHEDULED */.L.SCHEDULED;
}
function isStrategyCompleted(strategy) {
  return strategy.status === Strategy/* StrategyStatus.COMPLETED */.L.COMPLETED;
}
function isStrategyCancelled(strategy) {
  return strategy.status === Strategy/* StrategyStatus.CANCELLED */.L.CANCELLED;
}
function getStrategyBalance(strategy) {
  var _ref = strategy.rawData || {},
      balance = _ref.balance;

  return (0,getDenomInfo/* fromAtomic */.b1)(strategy.initialDenom, Number(balance.amount));
}
function getStrategyInitialDenomId(strategy) {
  return strategy.rawData.balance.denom;
}
function getStrategyInitialDenom(strategy) {
  return strategy.initialDenom;
}
function getStrategyResultingDenom(strategy) {
  return strategy.resultingDenom;
}
function getStrategyExecutionIntervalData(strategy) {
  if (strategy.rawData.time_interval instanceof Object) {
    var custom = strategy.rawData.time_interval.custom;
    var weeks = Math.floor(custom.seconds / constants/* SECONDS_IN_A_DAY */.K5 / constants/* DAYS_IN_A_WEEK */.Yx);
    var days = Math.floor(custom.seconds / constants/* SECONDS_IN_A_HOUR */.sb / constants/* HOURS_IN_A_DAY */.C4);
    var hours = Math.floor(custom.seconds / constants/* SECONDS_IN_A_MINUTE */.JJ / constants/* MINUTES_IN_A_HOUR */.Jh);
    var minutes = Math.floor(custom.seconds / constants/* SECONDS_IN_A_MINUTE */.JJ);

    if (custom) {
      if (custom.seconds % constants/* SECONDS_IN_A_WEEK */.Jp === 0) {
        return {
          timeInterval: 'weekly',
          timeIncrement: weeks
        };
      }

      if (custom.seconds % constants/* SECONDS_IN_A_DAY */.K5 === 0) {
        return {
          timeInterval: 'daily',
          timeIncrement: days
        };
      }

      if (custom.seconds % constants/* SECONDS_IN_A_HOUR */.sb === 0) {
        return {
          timeInterval: 'hourly',
          timeIncrement: hours
        };
      }

      if (custom.seconds % constants/* SECONDS_IN_A_MINUTE */.JJ === 0) {
        return {
          timeInterval: 'minute',
          timeIncrement: minutes
        };
      }
    }
  }

  var time_interval = strategy.rawData.time_interval;
  return {
    timeInterval: time_interval,
    timeIncrement: undefined
  };
}
function getStrategyExecutionInterval(strategy) {
  var _getStrategyExecution = getStrategyExecutionIntervalData(strategy),
      timeInterval = _getStrategyExecution.timeInterval,
      timeIncrement = _getStrategyExecution.timeIncrement;

  if (timeIncrement) {
    if (timeInterval === 'weekly') {
      return "".concat(timeIncrement, " Week");
    }

    if (timeInterval === 'daily') {
      return "".concat(timeIncrement, " Day");
    }

    if (timeInterval === 'hourly') {
      return "".concat(timeIncrement, " Hour");
    }

    if (timeInterval === 'minute') {
      return "".concat(timeIncrement, " Minute");
    }
  }

  return executionIntervalDisplay/* executionIntervalLabel */.y[timeInterval];
}
function getStrategyName(strategy) {
  if (strategy.rawData.label) {
    return strategy.rawData.label;
  }

  return "".concat(strategy.initialDenom.name, " to ").concat(strategy.resultingDenom.name, " - ").concat(getStrategyExecutionInterval(strategy));
}
function getSlippageTolerance(strategy) {
  var slippage_tolerance = strategy.rawData.slippage_tolerance;
  return slippage_tolerance ? Number((Number(slippage_tolerance) * 100).toFixed(2)) : undefined;
}
function getSlippageToleranceFormatted(strategy) {
  var slippageTolerance = getSlippageTolerance(strategy);
  return slippageTolerance ? "".concat(getSlippageTolerance(strategy), "%") : '-';
}
function getSwapAmount(strategy) {
  var _ref2 = strategy.rawData || {},
      swap_amount = _ref2.swap_amount;

  return Number(swap_amount);
}
function getStrategyType(strategy) {
  if ((0,isWeightedScale/* isWeightedScale */.U)(strategy)) {
    return (0,getDenomInfo/* isDenomStable */.dG)(strategy.initialDenom) ? StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn : StrategyType/* StrategyType.WeightedScaleOut */.h.WeightedScaleOut;
  }

  if ((0,strategy_isDcaPlus/* isDcaPlus */.o)(strategy)) {
    return (0,getDenomInfo/* isDenomStable */.dG)(strategy.initialDenom) ? StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn : StrategyType/* StrategyType.DCAPlusOut */.h.DCAPlusOut;
  }

  return (0,getDenomInfo/* isDenomStable */.dG)(strategy.initialDenom) ? StrategyType/* StrategyType.DCAIn */.h.DCAIn : StrategyType/* StrategyType.DCAOut */.h.DCAOut;
}
function getStrategyRemainingExecutions(strategy) {
  var balance = new bignumber/* default */.Z(strategy.rawData.balance.amount);
  var swapAmount = new bignumber/* default */.Z(strategy.rawData.swap_amount);
  return (0,totalExecutions/* default */.Z)(balance.toNumber(), swapAmount.toNumber());
}
function isBuyStrategy(strategy) {
  return getStrategyType(strategy) === StrategyType/* StrategyType.DCAIn */.h.DCAIn || getStrategyType(strategy) === StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn || getStrategyType(strategy) === StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn;
}
function getStrategyPriceTrigger(strategy) {
  var trigger = strategy.rawData.trigger;

  if (trigger && 'price' in trigger) {
    return trigger.price.target_price;
  }

  return undefined;
}
function getTargetPrice(strategy, pairs) {
  var target_price;

  if (getStrategyPriceTrigger(strategy)) {
    target_price = getStrategyPriceTrigger(strategy);
  }

  if (target_price) {
    var initialDenom = strategy.initialDenom,
        resultingDenom = strategy.resultingDenom;
    var pair = pairs && (0,findPair/* findPair */.d)(pairs, resultingDenom, initialDenom);

    if (pair && (0,utils_pair/* getBaseDenom */.m)(pair).id === strategy.initialDenom.id) {
      return (0,safeInvert/* safeInvert */.Z)(Number(target_price));
    }

    return Number(target_price);
  }

  return null;
}
function getNextTargetTime(strategy) {
  var started_at = strategy.rawData.started_at;
  var startTime = dayjs_min_default()(Number(started_at) / 1000000);
  var now = dayjs_min_default()();
  var diff = now.diff(startTime, 'seconds');

  if (strategy.rawData.time_interval instanceof Object) {
    var custom = strategy.rawData.time_interval.custom;

    var _iterations = Math.floor(diff / custom.seconds) + 1;

    return startTime.add(_iterations * custom.seconds, 'seconds').toDate();
  }

  var _getStrategyExecution2 = getStrategyExecutionIntervalData(strategy),
      timeInterval = _getStrategyExecution2.timeInterval;

  if (timeInterval === 'monthly') {
    var monthsDiff = now.diff(startTime, 'months') + 1;
    return startTime.add(monthsDiff, 'months').toDate();
  }

  var seconds = {
    minute: constants/* SECONDS_IN_A_MINUTE */.JJ,
    half_hourly: constants/* SECONDS_IN_A_HOUR */.sb / 2,
    hourly: constants/* SECONDS_IN_A_HOUR */.sb,
    half_daily: constants/* SECONDS_IN_A_DAY */.K5 / 2,
    daily: constants/* SECONDS_IN_A_DAY */.K5,
    weekly: constants/* SECONDS_IN_A_WEEK */.Jp,
    fortnightly: constants/* SECONDS_IN_A_WEEK */.Jp * 2
  }[timeInterval];
  var iterations = Math.floor(diff / seconds) + 1;
  return startTime.add(iterations * seconds, 'seconds').toDate();
}
function getStrategyStartDate(strategy, pairs) {
  var trigger = strategy.rawData.trigger;
  var initialDenom = strategy.initialDenom,
      resultingDenom = strategy.resultingDenom;
  var denom = isBuyStrategy(strategy) ? resultingDenom : initialDenom;
  var targetPrice = getTargetPrice(strategy, pairs);

  if (targetPrice) {
    var price = Number((0,getDenomInfo/* priceFromRatio */.Mb)(denom, targetPrice).toFixed(denom.pricePrecision));

    if (isBuyStrategy(strategy)) {
      return "When ".concat(resultingDenom.name, " hits ").concat(price, " ").concat(initialDenom.name);
    }

    return "When ".concat(initialDenom.name, " hits ").concat(price, " ").concat(resultingDenom.name);
  }

  if (isStrategyScheduled(strategy) && trigger && 'time' in trigger && trigger.time.target_time) {
    return new Date(Number(trigger.time.target_time) / 1000000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  }

  return strategy.rawData.started_at ? new Date(Number(strategy.rawData.started_at) / 1000000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }) : '-';
}
function getStrategyEndDateFromRemainingExecutions(strategy, events, executions) {
  var trigger = strategy.rawData.trigger;

  if (isStrategyScheduled(strategy) && trigger && 'time' in trigger) {
    var startDate = new Date(Number(trigger.time.target_time) / 1000000);
    return (0,formatDate/* formatDate */.p)((0,getEndDateFromRemainingExecutions/* getEndDateFromRemainingExecutions */.G)(strategy, startDate, executions));
  }

  if (!events) {
    return '-';
  }

  var lastExecutionDate = getLastExecutionDateFromStrategyEvents(events);

  if (isStrategyOperating(strategy) && lastExecutionDate) {
    return (0,formatDate/* formatDate */.p)((0,getEndDateFromRemainingExecutions/* getEndDateFromRemainingExecutions */.G)(strategy, lastExecutionDate, executions));
  }

  if (lastExecutionDate) {
    return lastExecutionDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  }

  return '-';
}
function getStrategyEndDate(strategy, events) {
  if (getStrategyPriceTrigger(strategy)) {
    return 'Pending strategy start';
  }

  var executions = getStrategyRemainingExecutions(strategy);
  return getStrategyEndDateFromRemainingExecutions(strategy, events, executions);
}
function isStrategyAutoStaking(strategy) {
  return isAutoStaking(strategy.rawData.destinations);
}
function convertReceiveAmount(strategy, receiveAmount) {
  var initialSF = strategy.initialDenom.significantFigures;
  var resultingSF = strategy.resultingDenom.significantFigures; // start with scaled receive amount

  var scaledReceiveAmount = Number(receiveAmount); // get unscaled receive amount

  var scalingFactor = 10 ** (resultingSF - initialSF);
  var unscaledReceiveAmount = scaledReceiveAmount / scalingFactor; // get directionless price

  var deconvertedSwapAmount = Number(getSwapAmount(strategy));
  var directionlessPrice = deconvertedSwapAmount / unscaledReceiveAmount; // get directed price

  var directedPrice = isBuyStrategy(strategy) ? directionlessPrice : (0,safeInvert/* safeInvert */.Z)(directionlessPrice);
  return Number(directedPrice.toFixed(6));
}
function getPriceThreshold(strategy) {
  if (!strategy.rawData.minimum_receive_amount) {
    return undefined;
  }

  return convertReceiveAmount(strategy, strategy.rawData.minimum_receive_amount);
}
function getBasePrice(strategy) {
  var _ref3 = (0,isWeightedScale/* getWeightedScaleConfig */.$)(strategy) || {},
      base_receive_amount = _ref3.base_receive_amount;

  if (!base_receive_amount) {
    return undefined;
  }

  return convertReceiveAmount(strategy, base_receive_amount);
}
function getStrategyTotalFeesPaid(strategy, dexFee) {
  var costAmount = strategy.rawData.swapped_amount.amount;
  var feeFactor = isDcaPlus(strategy) ? 0 : SWAP_FEE + dexFee + (isStrategyAutoStaking(strategy) ? DELEGATION_FEE : 0);
  return Number(costAmount) * feeFactor;
}
function getTotalSwapped(strategy) {
  return (0,getDenomInfo/* fromAtomic */.b1)(strategy.initialDenom, Number(strategy.rawData.swapped_amount.amount));
}
function getTotalReceived(strategy) {
  return (0,getDenomInfo/* fromAtomic */.b1)(strategy.resultingDenom, Number(strategy.rawData.received_amount.amount));
}
function getTotalReceivedBeforeFees(strategy, dexFee) {
  var feeFactor = !(0,strategy_isDcaPlus/* isDcaPlus */.o)(strategy) ? constants/* SWAP_FEE */.OJ + dexFee : dexFee;
  return getTotalReceived(strategy) / (1 - feeFactor);
}
function getAverageSellPrice(strategy, dexFee) {
  return getTotalReceivedBeforeFees(strategy, dexFee) / getTotalSwapped(strategy);
}
function getAveragePurchasePrice(strategy, dexFee) {
  return getTotalSwapped(strategy) / getTotalReceivedBeforeFees(strategy, dexFee);
}

/***/ }),

/***/ 67207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isDcaPlus; },
/* harmony export */   "u": function() { return /* binding */ getDcaPlusConfig; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function getDcaPlusConfig(strategy) {
  if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(strategy.rawData.performance_assessment_strategy) || (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(strategy.rawData.swap_adjustment_strategy)) {
    return null;
  }

  var _strategy$rawData = strategy.rawData,
      swap_adjustment_strategy = _strategy$rawData.swap_adjustment_strategy,
      performance_assessment_strategy = _strategy$rawData.performance_assessment_strategy,
      deposited_amount = _strategy$rawData.deposited_amount,
      escrow_level = _strategy$rawData.escrow_level,
      escrowed_amount = _strategy$rawData.escrowed_amount;

  if ('risk_weighted_average' in swap_adjustment_strategy) {
    return {
      total_deposit: deposited_amount,
      standard_dca_received_amount: performance_assessment_strategy === null || performance_assessment_strategy === void 0 ? void 0 : performance_assessment_strategy.compare_to_standard_dca.received_amount,
      standard_dca_swapped_amount: performance_assessment_strategy === null || performance_assessment_strategy === void 0 ? void 0 : performance_assessment_strategy.compare_to_standard_dca.swapped_amount,
      escrow_level: escrow_level,
      escrowed_balance: escrowed_amount,
      model_id: swap_adjustment_strategy === null || swap_adjustment_strategy === void 0 ? void 0 : swap_adjustment_strategy.risk_weighted_average.model_id
    };
  }

  return null;
}
function isDcaPlus(strategy) {
  return Boolean(getDcaPlusConfig(strategy));
}

/***/ }),

/***/ 19766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getWeightedScaleConfig; },
/* harmony export */   "U": function() { return /* binding */ isWeightedScale; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function getWeightedScaleConfig(strategy) {
  if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(strategy.rawData.swap_adjustment_strategy)) {
    return null;
  }

  if (!('weighted_scale' in strategy.rawData.swap_adjustment_strategy)) {
    return null;
  }

  var _strategy$rawData$swa = strategy.rawData.swap_adjustment_strategy.weighted_scale,
      base_receive_amount = _strategy$rawData$swa.base_receive_amount,
      increase_only = _strategy$rawData$swa.increase_only,
      multiplier = _strategy$rawData$swa.multiplier;
  return {
    base_receive_amount: base_receive_amount,
    increase_only: increase_only,
    multiplier: multiplier
  };
}
function isWeightedScale(strategy) {
  return Boolean(getWeightedScaleConfig(strategy));
}

/***/ }),

/***/ 22606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getCalcClient; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/helpers/chains/index.ts
var chains = __webpack_require__(87038);
// EXTERNAL MODULE: ./src/models/Strategy.ts
var Strategy = __webpack_require__(22149);
// EXTERNAL MODULE: ./src/utils/DenomInfo.ts
var DenomInfo = __webpack_require__(28933);
;// CONCATENATED MODULE: ./src/hooks/useCalcClient/getClient/clients/cosmos/transformToStrategy.ts


var vaultStatusMap = {
  active: Strategy/* StrategyStatus.ACTIVE */.L.ACTIVE,
  cancelled: Strategy/* StrategyStatus.CANCELLED */.L.CANCELLED,
  scheduled: Strategy/* StrategyStatus.SCHEDULED */.L.SCHEDULED,
  inactive: Strategy/* StrategyStatus.COMPLETED */.L.COMPLETED
};
function transformToStrategyCosmos(vaultData, getDenomById, chainId) {
  var _getDenomById, _getDenomById2;

  return {
    chainId: chainId,
    id: vaultData.id,
    owner: vaultData.owner,
    status: vaultStatusMap[vaultData.status],
    initialDenom: (_getDenomById = getDenomById(vaultData.balance.denom)) !== null && _getDenomById !== void 0 ? _getDenomById : (0,DenomInfo/* fromPartial */.Y)({
      id: vaultData.balance.denom,
      chain: chainId
    }),
    resultingDenom: (_getDenomById2 = getDenomById(vaultData.received_amount.denom)) !== null && _getDenomById2 !== void 0 ? _getDenomById2 : (0,DenomInfo/* fromPartial */.Y)({
      id: vaultData.balance.denom,
      chain: chainId
    }),
    rawData: vaultData
  };
}
;// CONCATENATED MODULE: ./src/hooks/useCalcClient/getClient/clients/cosmos/index.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function _fetchAllPairs2(_x, _x2, _x3) {
  return _fetchAllPairs.apply(this, arguments);
}

function _fetchAllPairs() {
  _fetchAllPairs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(chainId, contractAddress, client) {
    var startAfter,
        allPairs,
        _yield$queryContractS,
        pairs,
        newStartAfter,
        _args3 = arguments;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            startAfter = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
            allPairs = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : [];
            _context3.next = 4;
            return client.queryContractSmart(contractAddress, {
              get_pairs: {
                limit: (0,chains/* getPairsFetchLimit */.xs)(chainId),
                start_after: startAfter
              }
            });

          case 4:
            _yield$queryContractS = _context3.sent;
            pairs = _yield$queryContractS.pairs;
            allPairs.push.apply(allPairs, (0,toConsumableArray/* default */.Z)(pairs));

            if (!(pairs.length === (0,chains/* getPairsFetchLimit */.xs)(chainId))) {
              _context3.next = 10;
              break;
            }

            newStartAfter = pairs[pairs.length - 1];
            return _context3.abrupt("return", _fetchAllPairs2(chainId, contractAddress, client, newStartAfter, allPairs));

          case 10:
            return _context3.abrupt("return", allPairs);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchAllPairs.apply(this, arguments);
}

function _fetchVault2(_x4, _x5, _x6, _x7, _x8) {
  return _fetchVault.apply(this, arguments);
}

function _fetchVault() {
  _fetchVault = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(chainId, client, contractAddress, id, getDenomById) {
    var _ref3, vault;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return client.queryContractSmart(contractAddress, {
              get_vault: {
                vault_id: id
              }
            });

          case 2:
            _ref3 = _context4.sent;
            vault = _ref3.vault;
            return _context4.abrupt("return", transformToStrategyCosmos(vault, getDenomById, chainId));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchVault.apply(this, arguments);
}

function _fetchVaultEvents2(_x9, _x10, _x11, _x12, _x13) {
  return _fetchVaultEvents.apply(this, arguments);
}

function _fetchVaultEvents() {
  _fetchVaultEvents = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(chainId, client, contractAddress, id, getDenomById) {
    var vault, fetchEventsRecursively;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _fetchVault2(chainId, client, contractAddress, id, getDenomById);

          case 2:
            vault = _context6.sent;

            fetchEventsRecursively = /*#__PURE__*/function () {
              var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
                var startAfter,
                    allEvents,
                    _ref5,
                    events,
                    newStartAfter,
                    _args5 = arguments;

                return regenerator_default().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        startAfter = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
                        allEvents = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : [];
                        _context5.next = 4;
                        return client.queryContractSmart(contractAddress, {
                          get_events_by_resource_id: {
                            resource_id: id,
                            limit: (0,chains/* getEventsFetchLimit */.zF)(chainId),
                            start_after: startAfter
                          }
                        });

                      case 4:
                        _ref5 = _context5.sent;
                        events = _ref5.events;
                        allEvents.push.apply(allEvents, (0,toConsumableArray/* default */.Z)(events.map(function (e) {
                          return _objectSpread(_objectSpread({}, e), {}, {
                            initialDenom: vault.initialDenom,
                            resultingDenom: vault.resultingDenom
                          });
                        })));

                        if (!(events.length === (0,chains/* getEventsFetchLimit */.zF)(chainId) || events.length === (0,chains/* getEventsFetchLimit */.zF)(chainId) - 1)) {
                          _context5.next = 10;
                          break;
                        }

                        newStartAfter = events[events.length - 1].id;
                        return _context5.abrupt("return", fetchEventsRecursively(newStartAfter, allEvents));

                      case 10:
                        return _context5.abrupt("return", allEvents);

                      case 11:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function fetchEventsRecursively() {
                return _ref4.apply(this, arguments);
              };
            }();

            return _context6.abrupt("return", fetchEventsRecursively());

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchVaultEvents.apply(this, arguments);
}

function fetchVaultsByAddress(_x14, _x15, _x16, _x17, _x18) {
  return _fetchVaultsByAddress.apply(this, arguments);
}

function _fetchVaultsByAddress() {
  _fetchVaultsByAddress = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(chainId, client, contractAddress, userAddress, getDenomById) {
    var fetchVaultsByAddressRecursively;
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            fetchVaultsByAddressRecursively = /*#__PURE__*/function () {
              var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7() {
                var startAfter,
                    allVaults,
                    _yield$client$queryCo2,
                    vaults,
                    newStartAfter,
                    _args7 = arguments;

                return regenerator_default().wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        startAfter = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : null;
                        allVaults = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : [];
                        _context7.next = 4;
                        return client.queryContractSmart(contractAddress, {
                          get_vaults_by_address: {
                            address: userAddress,
                            limit: (0,chains/* getStrategiesFetchLimit */.ic)(chainId),
                            start_after: startAfter
                          }
                        });

                      case 4:
                        _yield$client$queryCo2 = _context7.sent;
                        vaults = _yield$client$queryCo2.vaults;
                        allVaults.push.apply(allVaults, (0,toConsumableArray/* default */.Z)(vaults.map(function (v) {
                          return transformToStrategyCosmos(v, getDenomById, chainId);
                        })));

                        if (!(vaults.length === (0,chains/* getStrategiesFetchLimit */.ic)(chainId))) {
                          _context7.next = 10;
                          break;
                        }

                        newStartAfter = vaults[vaults.length - 1].id;
                        return _context7.abrupt("return", fetchVaultsByAddressRecursively(newStartAfter, allVaults));

                      case 10:
                        return _context7.abrupt("return", allVaults);

                      case 11:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));

              return function fetchVaultsByAddressRecursively() {
                return _ref6.apply(this, arguments);
              };
            }();

            return _context8.abrupt("return", fetchVaultsByAddressRecursively());

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchVaultsByAddress.apply(this, arguments);
}

var _fetchAllVaults = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(chainId, client, contractAddress, getDenomById) {
    var fetchAllVaultsRecursively;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchAllVaultsRecursively = /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                var startAfter,
                    allVaults,
                    _yield$client$queryCo,
                    vaults,
                    newStartAfter,
                    _args = arguments;

                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        startAfter = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
                        allVaults = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
                        _context.next = 4;
                        return client.queryContractSmart(contractAddress, {
                          get_vaults: {
                            limit: (0,chains/* getStrategiesFetchLimit */.ic)(chainId),
                            start_after: startAfter
                          }
                        });

                      case 4:
                        _yield$client$queryCo = _context.sent;
                        vaults = _yield$client$queryCo.vaults;
                        allVaults.push.apply(allVaults, (0,toConsumableArray/* default */.Z)(vaults.map(function (v) {
                          return transformToStrategyCosmos(v, getDenomById, chainId);
                        })));

                        if (!(vaults.length === (0,chains/* getStrategiesFetchLimit */.ic)(chainId))) {
                          _context.next = 10;
                          break;
                        }

                        newStartAfter = vaults[vaults.length - 1].id;
                        return _context.abrupt("return", fetchAllVaultsRecursively(newStartAfter, allVaults));

                      case 10:
                        return _context.abrupt("return", allVaults);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function fetchAllVaultsRecursively() {
                return _ref2.apply(this, arguments);
              };
            }();

            return _context2.abrupt("return", fetchAllVaultsRecursively());

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllVaults(_x19, _x20, _x21, _x22) {
    return _ref.apply(this, arguments);
  };
}();

function getCalcClient(chainId, contractAddress, cosmWasmClient, getDenomById) {
  return {
    fetchAllPairs: function fetchAllPairs() {
      return _fetchAllPairs2(chainId, contractAddress, cosmWasmClient);
    },
    fetchVault: function fetchVault(id) {
      return _fetchVault2(chainId, cosmWasmClient, contractAddress, id, getDenomById);
    },
    fetchVaultEvents: function fetchVaultEvents(id) {
      return _fetchVaultEvents2(chainId, cosmWasmClient, contractAddress, id, getDenomById);
    },
    fetchVaults: function fetchVaults(userAddress) {
      return fetchVaultsByAddress(chainId, cosmWasmClient, contractAddress, userAddress, getDenomById);
    },
    fetchAllVaults: function fetchAllVaults() {
      return _fetchAllVaults(chainId, cosmWasmClient, contractAddress, getDenomById);
    }
  };
}

/***/ }),

/***/ 22149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ StrategyStatus; }
/* harmony export */ });
var StrategyStatus;

(function (StrategyStatus) {
  StrategyStatus["ACTIVE"] = "active";
  StrategyStatus["COMPLETED"] = "completed";
  StrategyStatus["CANCELLED"] = "cancelled";
  StrategyStatus["SCHEDULED"] = "scheduled";
})(StrategyStatus || (StrategyStatus = {}));

/***/ }),

/***/ 17987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getBaseDenom; },
/* harmony export */   "v": function() { return /* binding */ getQuoteDenom; }
/* harmony export */ });
var getBaseDenom = function getBaseDenom(pair) {
  return pair.denoms[0];
};
var getQuoteDenom = function getQuoteDenom(pair) {
  return pair.denoms[1];
};

/***/ }),

/***/ 90019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ safeInvert; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function safeInvert(value) {
  if (!value) {
    return 0;
  }

  if (!(0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNumber)(value)) {
    return 0;
  }

  return 1 / value;
}

/***/ }),

/***/ 66260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var totalExecutions = function totalExecutions(initialDeposit, swapAmount) {
  return Math.ceil(initialDeposit / swapAmount);
};

/* harmony default export */ __webpack_exports__["Z"] = (totalExecutions);

/***/ })

}]);